import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { proposalAPI } from '../../services/api';

const ProposalHistory = () => {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProposals();
  }, []);

  const fetchProposals = async () => {
    try {
      const response = await proposalAPI.getAll();
      setProposals(response.data);
    } catch (error) {
      console.error('Error fetching proposals:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = async (id, projectTitle) => {
    try {
      const response = await proposalAPI.downloadPDF(id);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert('Failed to download PDF');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Container fluid className="p-4">
      <Row className="mb-4 align-items-center">
        <Col>
          <h2 className="mb-0">
            <i className="bi bi-files me-2"></i>
            Proposal History
          </h2>
        </Col>
        <Col className="text-end">
          <Button as={Link} to="/proposals/generate" variant="primary">
            <i className="bi bi-plus-lg me-2"></i>
            Generate New
          </Button>
        </Col>
      </Row>

      <Card>
        <Card.Body className="p-0">
          <Table responsive hover className="mb-0">
            <thead className="table-dark">
              <tr>
                <th>Proposal #</th>
                <th>Project Title</th>
                <th>Client</th>
                <th>Estimated Cost</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {proposals.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-4">
                    No proposals found
                  </td>
                </tr>
              ) : (
                proposals.map((proposal) => (
                  <tr key={proposal._id}>
                    <td>
                      <Badge bg="secondary">{proposal.proposalNo}</Badge>
                    </td>
                    <td>{proposal.projectTitle}</td>
                    <td>{proposal.clientId?.clientName || 'N/A'}</td>
                    <td>{formatCurrency(proposal.estimatedCost)}</td>
                    <td>{formatDate(proposal.createdAt)}</td>
                    <td className="table-actions">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => handleDownloadPDF(proposal._id, proposal.projectTitle)}
                        title="Download PDF"
                      >
                        <i className="bi bi-download"></i>
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ProposalHistory;
